const NoHeaderPaths = () => {
    return [""];
  };
  
  export default NoHeaderPaths;